import axiosInstance from '../axiosInstance';

export const fetchServiceOrders = async () => {
  const res = await axiosInstance.get('/administration/service-orders');
  return res.data;
};

export const fetchBasciServiceOrders4Form = async () => {
  const res = await axiosInstance.get('/administration/service-orders/basic4form');
  return res.data;
};

export const fetchServiceOrdersPaginated = async ({ page = 1, limit = 10 }) => {
  const { data } = await axiosInstance.get('/administration/service-orders', {
    params: { page, limit },
  });
  return data;
};

export const fetchServiceManifests = async (serviceOrderId) => {
  const res = await axiosInstance.get(`/administration/service-orders/${serviceOrderId}/manifests`);
  return res.data;
};

export const createServiceOrder = async (data) => {
  const res = await axiosInstance.post('/administration/service-orders', data);
  return res.data;
};

export const updateServiceOrder = async (id, data) => {
  const res = await axiosInstance.put(`/administration/service-orders/${id}`, data);
  return res.data;
};

export const deleteServiceOrder = async (id) => {
  const res = await axiosInstance.delete(`/administration/service-orders/${id}`);
  return res.data;
};

/*export const fetchServiceOrderResumen = async () => {
    const res = await axiosInstance.get(`/administration/service-orders/resumen`);
    return res.data;
};*/

export const getServiceOrderById = async (id) => {
  const res = await axiosInstance.get(`/administration/service-orders/${id}`);
  return res.data;
};

// Cambiar el estado de una orden de servicio
export const changeServiceOrderState = async (id, newState) => {
  const response = await axiosInstance.post(`/administration/service-orders/${id}/change-state`, {
    newState,
  });
  return response.data;
};

// Buscar órdenes para autocompletado
export const fetchBasicServiceOrders = async (search = '', limit = 10, offset = 0) => {
  const res = await axiosInstance.get('/administration/service-orders/basic/search', {
    params: { search, limit, offset }
  });
  return res.data;
};

/*============= VIAJEROS-ORDEN DE SERVICIO ==========*/

// Obtener los viajeros de una orden de servicio
export const fetchViajeros = async (serviceOrderId) => {
  const response = await axiosInstance.get(`/administration/service-orders/${serviceOrderId}/details`);
  return response.data;
};

// Agregar un viajero a una orden de servicio
export const addViajero = async (serviceOrderId, data) => {
  const response = await axiosInstance.post(`/administration/service-orders/${serviceOrderId}/detail`, data);
  return response.data;
};

// Editar un viajero en una orden de servicio
export const updateViajero = async (serviceDeatilOrderId, data) => {
  const response = await axiosInstance.put(`/administration/service-orders/${serviceDeatilOrderId}/detail`, data);
  return response.data;
};

// Eliminar un viajero de una orden de servicio
export const deleteViajero = async (serviceOrderId, data) => {
  const response = await axiosInstance.delete(`/administration/service-orders/${serviceOrderId}/detail`, {
    data,
  });
  return response.data;
};

// Copiar viajeros desde una orden anterior
export const copyTravelersFromOrder = async (destinationId, payload) => {
  const res = await axiosInstance.post(`/administration/service-orders/${destinationId}/copy-details`, payload);
  return res.data;
};

// viajeros desde un archivo excel
export const bulkImportTravelers = async (serviceId, payload) => {
  const response = await axiosInstance.post(
    `/administration/service-orders/${serviceId}/travelers/bulk-import`,
    payload,
    { timeout: 120000 } // 120 segundos para archivos grandes
  );
  return response.data;
};
/*============= ORDEN SERVICIO - COLABORADOR==========*/
// Obtener los colaboradores de una orden de servicio
export const fetchCollaborators = async (serviceOrderId) => {
  const response = await axiosInstance.get(`/administration/service-orders/${serviceOrderId}/collaborators`);
  return response.data;
};

// Agregar un colaborador a una orden de servicio
export const addCollaborator = async (serviceOrderId, data) => {
  const response = await axiosInstance.post(`/administration/service-orders/${serviceOrderId}/collaborator`, data);
  return response.data;
};

// Eliminar un colaborador de una orden de servicio
export const deletellaborator = async (serviceOrderId, data) => {
  const response = await axiosInstance.delete(`/administration/service-orders/${serviceOrderId}/collaborator`, {
    data,
  });
  return response.data;
};

/*============= SERVICE MANIFEST DE SERVICIO ==========*/
export const updateServiceManifest = async (serviceOrderManifestId, data) => {
  const response = await axiosInstance.put(`/administration/service-orders/${serviceOrderManifestId}/manifest-order`, data);
  return response.data;
};


/*============= HISTORIAL ==========*/

// Obtener el historial de un servicio
export const fetchHistorial = async (id) => {
  const response = await axiosInstance.get(`/administration/service-orders/${id}/historial`);
  return response.data;
};

/*============= CLIENTE ==========*/
/*export const fetchClientServiceOrders = async ({ page = 1, limit = 25, search = "", status = "TODOS", projectId = "TODOS" }) => {
  const response = await axiosInstance.get("/administration/service-orders/client", {
    params: { page, limit, search, status, projectId },
  });
  return response.data;
};*/

export const fetchClientServiceOrders = async ({
  page = 1,
  limit = 25,
  search = "",
  status = "TODOS",
  situacion = "TODOS",
  projectId = "TODOS",
  fechaDesde = "",
  fechaHasta = "",
} = {}) => {
  // Solo enviamos los parámetros que realmente aplican (querystring limpio)
  const params = { page, limit };

  const clean = (v) => (typeof v === "string" ? v.trim() : v);

  const s = clean(search);
  if (s) params.search = s;

  if (status && status !== "TODOS") params.status = status;
  if (situacion && situacion !== "TODOS") params.situacion = situacion;
  if (projectId && projectId !== "TODOS") params.projectId = projectId;

  if (fechaDesde) params.fechaDesde = fechaDesde;   // formato YYYY-MM-DD
  if (fechaHasta) params.fechaHasta = fechaHasta;   // formato YYYY-MM-DD

  const response = await axiosInstance.get(
    "/administration/service-orders/client",
    { params }
  );

  return response.data;
};